var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3532 7.68754L13.1051 4.93568L13.3405 5.17274L11.5328 6.98043L10.6792 7.83399H11.8863H14.1663V8.16732H11.8863H10.6792L11.5328 9.02087L13.3405 10.8286L13.1051 11.0656L10.3532 8.31377L10.2068 8.16732H9.99967H8.66634H8.16634V8.66732V10.0007V10.2078L8.31279 10.3542L11.0646 13.1061L10.8276 13.3415L9.01989 11.5338L8.16634 10.6802V11.8873V14.1673H7.83301V11.8873V10.6802L6.97945 11.5338L5.17176 13.3415L4.9347 13.1061L7.68656 10.3542L7.83301 10.2078V10.0007V8.66732V8.16732H7.33301H5.99967H5.79257L5.64612 8.31377L2.89426 11.0656L2.65887 10.8286L4.46656 9.02087L5.32011 8.16732H4.11301H1.83301V7.83399H4.11301H5.32011L4.46656 6.98043L2.65887 5.17274L2.89426 4.93568L5.64612 7.68754L5.79257 7.83399H5.99967H7.33301H7.83301V7.33399V6.00065V5.79354L7.68656 5.6471L4.9347 2.89524L5.17176 2.65984L6.97945 4.46754L7.83301 5.32109V4.11398V1.83398H8.16634V4.11398V5.32109L9.01989 4.46754L10.8276 2.65984L11.0646 2.89524L8.31279 5.6471L8.16634 5.79354V6.00065V7.33399V7.83399H8.66634H9.99967H10.2068L10.3532 7.68754Z",
    fill: "#A5A5A8",
    stroke: "#A5A5A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcIcon);
export default __webpack_public_path__ + "static/media/acIcon.ee3491602d8b7acc615dfa45b1e0bcac.svg";
export { ForwardRef as ReactComponent };